<ng-container *transloco="let convert;">
  <div class="dealer-group-popover" role="region">
    @if (dealerGroups$ | async; as dealerGroups) {

      <!-- Multiple Groups Controls -->
      @if (isSellerAssociatedToMultipleLeadSellerGroup) {
        <div class="preferences-controls">

          <!-- Search Input -->
          <div class="form-group">
            <label
              for="preferences-search-input"
              class="text-uppercase d-block form-label">
              {{ convert('common.labelSearch') }}
            </label>
            <input
              id="preferences-search-input"
              type="text"
              class="form-control"
              (input)="search($event)" />
          </div>

          <!-- Select All Checkbox -->
          <div class="custom-control custom-checkbox">
            <input
              id="dealer-group-popover-select-all"
              type="checkbox"
              class="custom-control-input"
              [checked]="allSelected$ | async"
              [appTrack]="{ elem: 'checkbox', trigger: 'filter', name: 'All Groups' }"
              [attr.aria-describedby]="'select-all-description'"
              (change)="toggleAll()" />

            <label
              class="custom-control-label"
              for="dealer-group-popover-select-all">
              {{ convert('sellModule.manageInventory.preferencesPopover.labelAllGroups') }}
            </label>
          </div>
        </div>
      }

      <!-- Dealer Groups List -->
      @for (groupUuid of dealerGroups.groupUuids; track groupUuid; let index = $index) {
        <app-dealer-group-selection-section
          [groupUuid$]="groupUuid"
          [state$]="preferencesState$"
          [dealershipGroupCount$]="dealershipGroupCount"
          [leadSellerPreferencePopOver$]="true"
          [attr.data-group-index]="index"
          (selectGroup)="toggleGroup($event)"
          (selectMember)="toggleMember($event)">
        </app-dealer-group-selection-section>
      }
    }
  </div>
</ng-container>

